import * as React from 'react'
import PropTypes from 'prop-types'

import InfoCircle from './InfoCircle'
import cls from '../EventForm.module.scss'

const CardHeader = ({ title, stepNumber, info, showInfoCircle }) => (
  <div className={cls.cardHeader}>
    <p className={cls.stepNumber}>Step {stepNumber}</p>
    <p className={cls.stepDescription}>
      {title} {showInfoCircle && <InfoCircle info={info} />}
    </p>
  </div>
)

CardHeader.defaultProps = {
  showInfoCircle: true,
}

CardHeader.propTypes = {
  title: PropTypes.string,
  stepNumber: PropTypes.string,
  info: PropTypes.string,
  showInfoCircle: PropTypes.bool,
}

export default CardHeader
